/* MSS Modbar — bar illustration, example switcher and system builder.
   Progressive enhancement: every section is fully server-rendered by Liquid
   (snippets/mss-modbar-bar.liquid) and works without this file. Layout
   constants below must match that snippet. */
(function () {
  'use strict';
  if (window.MSSModbar) return;

  var NS = 'http://www.w3.org/2000/svg';
  var TS = 130, GAP = 40, MIN_GW = 200, SYM_W = 132, SYM_H = 198, COUNTER = 252, FLOOR = 426;
  var NAMES = { av: 'ESPRESSO AV', st: 'STEAM', po: 'POUR-OVER' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseConfig(str) {
    var p = String(str || '').split(',');
    return {
      esp: +p[0] || 0, espTaps: +p[1] || 1, abr: p[2] === '1',
      steam: +p[3] || 0, steamTaps: +p[4] || 1,
      po: +p[5] || 0, poConfig: p[6] || '1'
    };
  }

  function groupsFor(c) {
    var g = [], i;
    for (i = 0; i < c.esp; i++) g.push({ kind: 'av', n: c.espTaps, abr: c.abr });
    for (i = 0; i < c.steam; i++) g.push({ kind: 'st', n: c.steamTaps });
    for (i = 0; i < c.po; i++) g.push({ kind: 'po', n: c.poConfig === '1' ? 1 : 2, faucet: c.poConfig === 'faucet' });
    return g;
  }

  function layout(c) {
    var groups = groupsFor(c), total = 0;
    groups.forEach(function (g) { g.gw = Math.max(g.n * TS, MIN_GW); total += g.gw + GAP; });
    if (total > 0) total -= GAP;
    var s = total > 0 ? Math.min(1, 900 / total) : 1;
    var x0 = (1000 - total * s) / 2, gx = 0, items = [], count = { av: 0, st: 0, po: 0, fa: 0 }, mods = { av: 0, st: 0, po: 0 };
    groups.forEach(function (g) {
      var mx = (gx + g.gw / 2) * s + x0;
      var first = gx + (g.gw - g.n * TS) / 2 + TS / 2;
      var mtop = FLOOR - 96 * s;
      for (var t = 1; t <= g.n; t++) {
        var cx = (first + (t - 1) * TS) * s + x0;
        var sym = (g.faucet && t === 2) ? 'fa' : g.kind;
        var tx = mx + (t * 2 - g.n - 1) * 9 * s;
        var key = sym + '-' + (count[sym]++);
        items.push({ type: 'tap', key: key, sym: sym, cx: cx, s: s, abr: !!g.abr, line: 'M' + cx + ' 272 V304 H' + tx + ' V' + mtop });
      }
      items.push({ type: 'mod', key: g.kind + '-' + (mods[g.kind]++), kind: g.kind, x: mx - 78 * s, y: mtop, s: s });
      gx += g.gw + GAP;
    });
    return items;
  }

  function el(name, attrs) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    return n;
  }

  function buildTap(uid, it) {
    var g = el('g', { 'class': 'mb-tap mb-anim', 'data-key': 'tap-' + it.key });
    if (it.sym !== 'fa') {
      g.appendChild(el('rect', { x: -44, y: -6, width: 88, height: 7, rx: 2, fill: 'url(#' + uid + '-metal)', stroke: '#8a969c', 'stroke-width': '.8' }));
      if (it.abr) g.appendChild(el('rect', { x: -30, y: -12, width: 60, height: 6, rx: 1.5, fill: '#20242a', 'class': 'mb-abr' }));
    }
    var u = el('use', { x: -SYM_W / 2, y: -SYM_H, width: SYM_W, height: SYM_H });
    u.setAttribute('href', '#' + uid + '-' + it.sym);
    g.appendChild(u);
    return g;
  }

  function buildMod(it, compact) {
    var g = el('g', { 'class': 'mb-modg mb-anim', 'data-key': 'mod-' + it.key });
    g.appendChild(el('rect', { width: 156, height: 96, rx: 7, fill: '#243d70', stroke: '#3c5a93' }));
    g.appendChild(el('rect', { x: 14, y: 14, width: 128, height: 4, rx: 2, fill: '#92e4f6', 'fill-opacity': '.45' }));
    g.appendChild(el('rect', { x: 14, y: 24, width: 128, height: 4, rx: 2, fill: '#92e4f6', 'fill-opacity': '.25' }));
    g.appendChild(el('circle', { cx: 140, cy: 82, r: 3.5, fill: '#f2e257' }));
    if (!compact) {
      var t1 = el('text', { 'class': 'mb-mod', x: 78, y: 60 }); t1.textContent = NAMES[it.kind];
      var t2 = el('text', { 'class': 'mb-mod mb-mod--sub', x: 78, y: 77 }); t2.textContent = 'MODULE';
      g.appendChild(t1); g.appendChild(t2);
    }
    return g;
  }

  function setPos(node, x, y, s) {
    node.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
  }

  /* Draw (or re-draw, animating) the bar inside an existing server-rendered svg. */
  function draw(svg, cfg, opts) {
    opts = opts || {};
    var uid = svg.getAttribute('data-mb-uid');
    var dyn = svg.querySelector('.mb-dyn');
    if (!dyn) return;
    var compact = svg.classList.contains('mb-bar--compact');
    if (!dyn.hasAttribute('data-mb-live')) { dyn.innerHTML = ''; dyn.setAttribute('data-mb-live', ''); }
    var animate = opts.animate && !reduceMotion;
    var items = layout(cfg);
    var existing = {};
    Array.prototype.forEach.call(dyn.querySelectorAll('[data-key]'), function (n) { existing[n.getAttribute('data-key')] = n; });

    // Lines: redrawn each time, faded in after movement.
    var linesG = dyn.querySelector('.mb-lines');
    if (!linesG) { linesG = el('g', { 'class': 'mb-lines' }); dyn.insertBefore(linesG, dyn.firstChild); }
    linesG.innerHTML = '';
    if (animate) { linesG.style.opacity = '0'; }

    var keep = {};
    items.forEach(function (it) {
      var key = (it.type === 'tap' ? 'tap-' : 'mod-') + it.key;
      keep[key] = true;
      var node = existing[key];
      var fresh = !node;
      if (fresh) {
        node = it.type === 'tap' ? buildTap(uid, it) : buildMod(it, compact);
        dyn.appendChild(node);
      } else if (it.type === 'tap') {
        var abr = node.querySelector('.mb-abr');
        if (it.abr && !abr && it.sym !== 'fa') {
          node.insertBefore(el('rect', { x: -30, y: -12, width: 60, height: 6, rx: 1.5, fill: '#20242a', 'class': 'mb-abr' }), node.querySelector('use'));
        } else if (!it.abr && abr) { abr.parentNode.removeChild(abr); }
      }
      var x = it.type === 'tap' ? it.cx : it.x;
      var y = it.type === 'tap' ? COUNTER : it.y;
      if (fresh && animate) {
        node.style.transition = 'none';
        setPos(node, x, y + (it.type === 'tap' ? -24 : 24), it.s);
        node.style.opacity = '0';
        node.getBoundingClientRect();
        node.style.transition = '';
      }
      setPos(node, x, y, it.s);
      node.style.opacity = '1';
      if (it.type === 'tap') linesG.appendChild(el('path', { 'class': 'mb-line', d: it.line }));
    });

    Object.keys(existing).forEach(function (k) {
      if (keep[k]) return;
      var n = existing[k];
      if (animate) { n.style.opacity = '0'; setTimeout(function () { if (n.parentNode && n.style.opacity === '0') n.parentNode.removeChild(n); }, 450); }
      else n.parentNode.removeChild(n);
    });
    if (animate) setTimeout(function () { linesG.style.opacity = '1'; }, 380);
  }

  /* ---------- Example switcher: [data-mb-examples] ---------- */
  function initExamples(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mb-panel]'));
    var stage = root.querySelector('[data-mb-stage] svg');
    if (!tabs.length || !stage) return;
    root.classList.add('is-enhanced');

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
      draw(stage, parseConfig(tabs[i].getAttribute('data-mb-config')), { animate: true });
      var title = stage.querySelector('title');
      if (title) title.textContent = tabs[i].getAttribute('data-mb-label') || title.textContent;
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); select(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = tabs.length;
        if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
        else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
        else if (k === 'Home') { e.preventDefault(); select(0, true); }
        else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
      });
    });
    // Swipe on the stage (touch).
    var sx = null;
    var area = root.querySelector('[data-mb-stage]');
    area.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    area.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) < 40) return;
      var cur = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      select(dx < 0 ? Math.min(cur + 1, tabs.length - 1) : Math.max(cur - 1, 0));
    });
    select(0);
  }

  /* ---------- System builder: [data-mb-builder] ---------- */
  function money(pence) {
    var v = (Math.round(pence) / 100).toFixed(2).split('.');
    return '£' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (v[1] === '00' ? '' : '.' + v[1]);
  }

  function initBuilder(root) {
    var form = root.querySelector('form');
    var svg = root.querySelector('[data-mb-stage] svg');
    if (!form) return;
    root.classList.add('is-enhanced');
    var summaryList = root.querySelector('[data-mb-summary]');
    var totalEx = root.querySelector('[data-mb-total-ex]');
    var totalInc = root.querySelector('[data-mb-total-inc]');
    var submit = root.querySelector('[data-mb-submit]');
    var err = root.querySelector('[data-mb-error]');
    var quote = root.querySelector('[data-mb-quote]');
    var quoteBase = quote ? quote.getAttribute('data-mb-quote-base') : '';
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mb-group]'));

    function readGroup(g) {
      var qtyInput = g.querySelector('[data-mb-qty]');
      var qty = Math.max(0, Math.min(+qtyInput.max || 9, parseInt(qtyInput.value, 10) || 0));
      var radio = g.querySelector('input[type=radio]:checked');
      return { el: g, sys: g.getAttribute('data-mb-group'), qty: qty, radio: radio, input: qtyInput };
    }

    function update(animate) {
      var cfg = { esp: 0, espTaps: 1, abr: false, steam: 0, steamTaps: 1, po: 0, poConfig: '1' };
      var lines = [], total = 0, parts = [];
      groups.forEach(function (g) {
        var r = readGroup(g);
        g.classList.toggle('is-off', r.qty === 0);
        var dec = g.querySelector('[data-mb-step="-1"]'), inc = g.querySelector('[data-mb-step="1"]');
        if (dec) dec.disabled = r.qty <= 0;
        if (inc) inc.disabled = r.qty >= (+r.input.max || 9);
        if (!r.radio || r.qty === 0) return;
        var d = r.radio.dataset;
        if (r.sys === 'av') { cfg.esp = r.qty; cfg.espTaps = +d.taps; cfg.abr = d.abr === '1'; }
        if (r.sys === 'st') { cfg.steam = r.qty; cfg.steamTaps = +d.taps; }
        if (r.sys === 'po') { cfg.po = r.qty; cfg.poConfig = d.po; }
        var price = +d.price * r.qty;
        total += price;
        lines.push('<li><span>' + r.qty + ' × ' + d.name + '</span><span>' + money(price / 1.2) + '</span></li>');
        parts.push(r.qty + ' x ' + d.name);
      });
      if (svg) draw(svg, cfg, { animate: animate });
      if (summaryList) summaryList.innerHTML = lines.length ? lines.join('') : '<li class="is-empty">Choose at least one system.</li>';
      if (totalEx) totalEx.textContent = money(total / 1.2);
      if (totalInc) totalInc.textContent = money(total);
      if (submit) submit.disabled = !lines.length;
      if (quote && quoteBase) {
        quote.href = quoteBase + (quoteBase.indexOf('?') > -1 ? '&' : '?') + 'product=' + encodeURIComponent('La Marzocco Modbar') +
          (parts.length ? '&configuration=' + encodeURIComponent(parts.join(', ')) : '');
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mb-step]');
      if (b) {
        var input = b.closest('[data-mb-group]').querySelector('[data-mb-qty]');
        input.value = Math.max(0, Math.min(+input.max || 9, (parseInt(input.value, 10) || 0) + +b.getAttribute('data-mb-step')));
        update(true);
        return;
      }
      var p = e.target.closest('[data-mb-preset]');
      if (p) {
        e.preventDefault();
        applyPreset(p.getAttribute('data-mb-preset'));
      }
    });
    form.addEventListener('change', function () { update(true); });
    form.addEventListener('input', function (e) { if (e.target.matches('[data-mb-qty]')) update(true); });

    function applyPreset(str) {
      var c = parseConfig(str);
      groups.forEach(function (g) {
        var sys = g.getAttribute('data-mb-group');
        var qty = sys === 'av' ? c.esp : sys === 'st' ? c.steam : c.po;
        g.querySelector('[data-mb-qty]').value = qty;
        var pick = null;
        Array.prototype.forEach.call(g.querySelectorAll('input[type=radio]'), function (r) {
          var d = r.dataset;
          if (sys === 'av' && +d.taps === c.espTaps && (d.abr === '1') === c.abr) pick = r;
          if (sys === 'st' && +d.taps === c.steamTaps) pick = r;
          if (sys === 'po' && d.po === c.poConfig) pick = r;
        });
        if (pick) pick.checked = true;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-mb-preset]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mb-preset') === str ? 'true' : 'false');
      });
      update(true);
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var items = [];
      groups.forEach(function (g) {
        var r = readGroup(g);
        if (r.qty > 0 && r.radio) items.push({ id: +r.radio.value, quantity: r.qty });
      });
      if (!items.length) return;
      if (err) { err.hidden = true; err.textContent = ''; }
      submit.disabled = true; submit.classList.add('is-loading');
      var root_url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(root_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'Could not add to basket');
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (x) {
          if (err) { err.textContent = x.message + '. Please try again, or request an installed quote.'; err.hidden = false; }
          submit.disabled = false; submit.classList.remove('is-loading');
        });
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('setup')) applyPreset(params.get('setup')); else update(false);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mb-examples]'), initExamples);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mb-builder]'), initBuilder);
  }

  window.MSSModbar = { draw: draw, parseConfig: parseConfig, initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
